'use strict';

/* global $ */

import { breakpoints } from '../settings'

function Sliders(options) {

    $('.js-home-slider').each(function() {
        HomeSlider(this); 
    });


    $('.js-slider-anime').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        infinite: false,
        draggable: false,
        accessibility: false,
        asNavFor: '.js-home-slider',
        responsive: [
            {
                breakpoint: breakpoints.xs,
                settings: {
                    dots: false,
                    infinite: true
                }
            },
        ]
    });

    $('.js-cervice-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '.js-cervice-slider-arrow.m--prev',
        nextArrow: '.js-cervice-slider-arrow.m--next',
        arrows: true,
        dots: false,
        fade: false,
        infinite: false,
        draggable: false,
        accessibility: false,
        responsive: [
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 3.5,
                    dots: false,
                    infinite: false
                }
            },
            {
                breakpoint: breakpoints.m,
                settings: {
                    slidesToShow: 3,
                    dots: false,
                    infinite: false
                }
            },

            {
                breakpoint: breakpoints.s+120,
                settings: {
                    slidesToShow: 2.5,
                    dots: false,
                    infinite: false
                }
            },
            {
                breakpoint: breakpoints.s,
                settings: {
                    slidesToShow: 2,
                    dots: false,
                    infinite: false
                }
            },
            {
                breakpoint: breakpoints.xs,
                settings: {
                    slidesToShow: 1.5,
                    dots: false,
                    infinite: false
                }
            },
            {
                breakpoint: breakpoints.xxs,
                settings: {
                    slidesToShow: 1,
                    dots: false,
                    infinite: false
                }
            },
        ]
    });

    $('.js-activ-slider-main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '.js-activ-slider-arrow.m--prev',
        nextArrow: '.js-activ-slider-arrow.m--next',
        arrows: true,
        appendDots: '.js-activ-slider-main',
        dotsClass: 'product-page__slider-dots js-home-slider-dots',
        dots: true,
        infinite: false,
        fade: false,
        draggable: false,
        centerMode: false,
        accessibility: false
    });
}

function HomeSlider(item) {
    let autoplay = false;
    let delay = 0;
    let $item = $(item);
    if ($item.data() && $item.data().delay > 0) {
        delay = $item.data().delay * 1000;
        autoplay = true;
    }

    $(item).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: '.js-home-slider-nav',
        prevArrow: '.js-home-slider-arrow.m--prev',
        nextArrow: '.js-home-slider-arrow.m--next',
        appendDots: '.js-home-slider-nav',
        dotsClass: 'header__slider-dots js-home-slider-dots',
        arrows: true,
        dots: true,
        fade: true,
        infinite: false,
        draggable: false,
        accessibility: false,
        autoplaySpeed: delay,
        autoplay: autoplay,
        asNavFor: '.js-slider-anime',
        responsive: [
            {
                breakpoint: breakpoints.xs,
                settings: {
                    dots: false,
                    infinite: true
                }
            },
        ]
    });
}

export {
    Sliders
};